import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAnimationIconComponent } from './mat-animation-icon/mat-animation-icon.component';
import {MatIconModule} from '@angular/material/icon';



@NgModule({
  declarations: [MatAnimationIconComponent],
  exports: [
    MatAnimationIconComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ]
})
export class MatAnimationIconModule { }
